import { BaseFetch } from "../main-model"
export default class ReportAnnouncementModel extends BaseFetch {
    getReportAnnouncementYearBy = (data) =>
    this.authFetch({
      url: "report-announcement/getReportAnnouncementYearBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportAnnouncementBy = (data) =>
    this.authFetch({
      url: "report-announcement/getReportAnnouncementBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
